export const AG_GRID_LOCALE_UZ = {
  // 🌐 General
  selectAll: 'Hammasini tanlash',
  selectAllSearchResults: 'Qidiruv natijalarini tanlash',
  addFilter: 'Filtr qo‘shish',
  clearFilter: 'Filtrni tozalash',
  applyFilter: 'Filtrni qo‘llash',
  resetFilter: 'Tiklash',
  searchOoo: 'Qidiruv...',
  equals: 'Teng',
  notEqual: 'Teng emas',
  lessThan: 'Kichikroq',
  greaterThan: 'Kattaroq',
  lessThanOrEqual: 'Kichik yoki teng',
  greaterThanOrEqual: 'Katta yoki teng',
  inRange: 'Diapazonda',
  inRangeStart: 'Diapazonda (bosh)',
  inRangeEnd: 'Diapazonda (oxir)',
  contains: 'O‘z ichiga oladi',
  notContains: 'O‘z ichiga olmaydi',
  startsWith: 'Boshida',
  endsWith: 'Tugada',
  before: 'Oldin',
  after: 'Keyin',
  andCondition: 'Va',
  orCondition: 'Yoki',
  and: 'Va',
  or: 'Yoki',
  not: 'Yo‘q',
  is: 'Ijobiy',
  isNot: 'Manfiy',
  isEmpty: 'Bo‘sh',
  isNotEmpty: 'Bo‘sh emas',
  isNull: 'NULL',
  isNotNull: 'NULL emas',
  isBlank: 'Bo‘sh',
  isNotBlank: 'Bo‘sh emas',

  // 🧮 Filter & Sorting
  filterOoo: 'Filtr...',
  blanks: 'Bo‘sh joylar',
  blank: 'Bo‘sh joy',
  notBlank: 'Bo‘sh joy emas',
  dateFormatOoo: 'yyyy-mm-dd',

  // 📋 Menu / Context
  copy: 'Nusxa olish',
  paste: 'Joylashtirish',
  export: 'Eksport',
  csvExport: 'CSV eksport',
  excelExport: 'Excel eksport',

  // 📄 Pagination
  pageSizeSelectorLabel: 'Sahifa o‘lchami',
  page: 'Sahifa',
  more: 'Ko‘proq',
  to: 'dan',
  of: 'jami',
  next: 'Keyingi',
  last: 'Oxirgi',
  first: 'Birinchi',
  previous: 'Oldingi',
  loadingOoo: 'Yuklanmoqda...',

  // 📊 Columns
  columns: 'Ustunlar',
  filters: 'Filtrlar',
  group: 'Guruh',
  rowGroupColumnsEmptyMessage: 'Guruhlash uchun ustunni shu yerga torting',
  valueColumnsEmptyMessage: 'Qiymatlar uchun ustunni shu yerga torting',

  // 🔍 Other UI
  noRowsToShow: 'Ko‘rsatish uchun ma’lumot yo‘q',
  pinColumn: 'Ustunni mahkamlash',
  autosizeThiscolumn: 'Ustunni avtomatik o‘lchash',
  resetColumns: 'Ustunlarni tiklash',
  expandAll: 'Barchasini yoyish',
  collapseAll: 'Barchasini yig‘ish',

  // 🧭 Aggregation
  sum: 'Yig‘indi',
  min: 'Minimum',
  max: 'Maksimum',
  none: 'Yo‘q',
  count: 'Soni',
  avg: 'O‘rtacha',
}
